import styled from "styled-components";

export const ButtonWrapper = styled.div<{ buttonWidth: string }>`
    display: inline-flex;
    width: ${({ buttonWidth }) => buttonWidth};
`;

export const TooltipContent = styled.div`
    max-width: 230px;
    overflow: hidden;
    text-overflow: ellipsis;
`;
